<template>
  <div>
    <template v-if="hasMsg">
      <gj-tooltip
          width-auto
          :text-line="1">
        <div v-html="strategyHtml"></div>
        <template #content>
          <div style="line-height: 20px;">
            <div v-for="(item, i) in data"
                 :key="i">
              <div v-for="(jtem, j) in item.data"
                   :key="j">
              <span class="week-set-text">
                <template v-if="j === 0">{{item.week | optionText(AdStrategyEnum.repeatOption)}}：</template>
              </span>
                <span>{{ strategy(jtem) }}</span>
              </div>
            </div>
          </div>
        </template>
      </gj-tooltip>
    </template>
    <template v-else>-</template>
  </div>
</template>

<script>
  import {isMeaningfulMixin} from "../../../../../../minxins";
  import {isMeaningful} from "../../../../../../utils/common";
  import {AdStrategyEnum} from "../../common/enum";
  import {convertToDate, convertToFullDate} from "../../../../../../utils/date.util";
  import {optionText} from "../../../../../../filters";

  export default {
    name: "app-placement-strategy-set-info",
    mixins: [isMeaningfulMixin],
    props: {
      item: {
        required: true
      }
    },
    data() {
      return {
        AdStrategyEnum: AdStrategyEnum
      };
    },
    computed: {
      data() {
        const data = [];
        const placementDailies = this.item.templateExpressionValue.placementDailies.expression;
        if (this.hasMsg) {
          const dateList = this._.flatMap(placementDailies, (item) => {
            return (item.dateList || []).map(date => ({
              ...item,
              date,
            }));
          });
          // { 1: [{}, {}] }
          const dateObj = this._.groupBy(dateList, 'date');
          this._.forIn(dateObj, (value, key) => {
            data.push({
              week: Number(key),
              data: this._.sortBy(value, 'startHour')
            });
          });
        }
        return this._.sortBy(data, item => item.week);
      },
      hasMsg() {
        if (isMeaningful(this.item.templateExpressionValue)
          && isMeaningful(this.item.templateExpressionValue.placementDailies)
          && isMeaningful(this.item.templateExpressionValue.placementDailies.expression)
          && this.item.templateExpressionValue.placementDailies.expression.length > 0) {
          return true;
        }
        return false;
      },
      strategyHtml() {
        if (!this.hasMsg) {
          return '-';
        }
        return this.data.map((item, i) => {
          return `${optionText(item.week, AdStrategyEnum.repeatOption)}：${item.data.map(jtem => this.strategy(jtem)).join('；')}`
        }).join('<br />');
      }
    },
    methods: {
      strategy(data) {
        const startHour = `${data.startHour}:00`
        const endHour = `${data.endHour}:00`
        let budgetTypeText = '';
        if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD) {
          budgetTypeText = `增加${data.value}% ${data.max ? '最多调整 ' + data.max + '%': ''}`;
        } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB) {
          budgetTypeText = `减少${data.value}% ${data.max ? '最低调整到 ' + data.max  + '%': ''}`;
        } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_ADD) {
          budgetTypeText = `提高${data.value}%`;
        } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_SUB) {
          budgetTypeText = `降低${data.value}%`;
        } else if (data.budgetType === AdStrategyEnum.adjustForm.adjustType.VALUE_FIXED) {
          budgetTypeText = `直接设置为${data.value}%`;
        }
        return `${startHour} 至 ${endHour} 广告位 ${budgetTypeText}`;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "common";
</style>
























